import { FleekError } from './FleekError';

type SecretKeyAlreadyExistsErrorOptions = Record<string, never>;

export class SecretKeyAlreadyExistsError extends FleekError<SecretKeyAlreadyExistsErrorOptions> {
  public name = 'SecretKeyAlreadyExistsError';

  toString = () => {
    return 'Variable with this key is already set.';
  };
}
